import type { ImageAttributes } from "./type";

export const DEFAULT_ATTRIBUTES: ImageAttributes = {
  width: "100%",
  src: "",
  aspectRatio: null,
  maxWidth: null,
  minWidth: null,
  alt: "",
  caption: null,
  frameborder: false,
  allowfullscreen: false,
  id: null,
  placeholder: null,
  align: "left",
};

export const EXTENSION_NAME = "image";
